<template>
  <div class=" is-fullwidth">
    <div class="level">
        <div class="level-left">
          <div class="columns" >
              <div class="select col">
                <select v-model="range" :disabled="this.orders_loading==true">
                  <option value="">Select Range</option>
                  <option value="Jerseys">Jerseys</option>
                  <option value="Leisurewear">Leisurewear</option>
                  <option value="Socks">Socks</option>
                  <option value="Shorts">Shorts</option>
                </select>
              </div>
            

             <div class=" col pl-2">
                <input type="date" class="input" v-model="start_date" :disabled="this.orders_loading==true"/>
                
              </div>
              <div class=" col pl-2" >
                <input type="date" class="input" v-model="end_date" :disabled="this.orders_loading==true"/>
                
              </div>

              <div class="col pl-2">
                  <table class="table is-hoverable is-bordered " id="overviewtable" >
                    <tbody>
                      <tr>
                        <td class="">Total Early Orders</td>
                        <td>{{ earlyOrders.length }}</td>
                      
                        </tr>
                    </tbody>
                  </table>
                </div>
            </div>
      </div>
        <div class="level-right">
        <button @click="resetOrders()" class="level-item button is-warning " v-if="client_id>0">Return to Customer List</button>
      </div>
      </div>
    
    <table class="table is-hoverable is-fullwidth" id="userstable" v-if="sortedUsers.length > 0">
    	<thead>
    		<tr>
        <th>Username <span v-if="username != ''" @click="username = ''" style="cursor:pointer"> (show all)</span></th>
        <th>Early Orders</th>
        
   	 	    </tr>
    	</thead>
    	<tbody>
		    
        <tr v-for="row in sortedUsers" v-bind:key="row.username" >
          <td ><span style="cursor:pointer" @click="username = row.username">{{row.username}}</span></td>
          <td>{{row.count}}</td>
         
              
			</tr>
    	</tbody>
    </table>
    

    <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable" >
    	<thead>
    		<tr>
        <th>PO Number</th>
        <th>Customer</th>
        <th>Range</th>
        <th>Design Name</th>
          <th>Qty</th>
          <th>Order Date</th>
          <th>Calculated Delivery</th>
          <th>Chosen Delivery</th>
           <th>Difference</th>
          <th>&nbsp;</th>
   	 	    </tr>
    	</thead>
    	<tbody>
		    <tr v-if="orders_loading===true">
          <td colspan="9"><strong>Loading orders ...</strong></td>
          </tr>
        <tr v-for="order in earlyOrders" v-bind:key="order.orderID" v-show="orders_loading===false">
          <td >{{order.ponumber}}</td>
          <td>{{order.clientname}}</td>
          <td>{{order.range}}</td>
          <td>{{order.designname}}</td>
           <td>{{ order.total_qty }}</td>
          <td>{{order.orderdate}}</td>
          <td>{{order.expecteddeliverydate}}</td>
         
          <td :class="{'has-text-success': order.early===true}">{{order.deliverydate}}</td>
            <td>{{order.datedifference}}</td>
          <td>
            <a :href="VUE_APP_ASP_URL + '/printorder.asp?txtPONumber=' + order.ponumber" target="_blank"><button class="button is-info is-small">View</button></a>
          </td>    
			</tr>
      </tbody>
      <tfoot v-if="earlyOrders.length> 0">
          <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td><strong>{{ report_total_qty }}</strong></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
        </tfoot>
    	
    </table>

    <button @click="exportXLS()" class="button is-info" >Export to Excel</button>

    <table class="" id="orderstable-excel" style="display:none" >
    	<thead>
    		<tr>
        <th>PO Number</th>
        <th>Customer</th>
        <th>Range</th>
        <th>Design Name</th>
          <th>Qty</th>
          <th>Order Date</th>
          <th>Calculated Delivery</th>
          <th>Chosen Delivery</th>
           <th>Difference</th>
          
   	 	    </tr>
    	</thead>
    	<tbody>
		    
        <tr v-for="order in earlyOrders" v-bind:key="order.orderID" v-show="orders_loading===false">
          <td >{{order.ponumber}}</td>
          <td>{{order.clientname}}</td>
          <td>{{order.range}}</td>
          <td>{{order.designname}}</td>
           <td>{{ order.total_qty }}</td>
          <td>{{order.orderdate_iso}}</td>
          <td>{{order.expecteddeliverydate_iso}}</td>
         
          <td >{{order.deliverydate_iso}}</td>
            <td>{{order.datedifference}}</td>
             
			</tr>
      </tbody>
      <tfoot v-if="earlyOrders.length> 0">
          <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td><strong>{{ report_total_qty }}</strong></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
             
            </tr>
        </tfoot>
    	
    </table>

     
    
  </div>
</template>

<script>

import OrderService from '@/services/OrderService.js';
import SalesService from '@/services/SalesService.js';
import XLSX from 'xlsx';

export default {
  name:'EarlyOrders',
  components: {
   	
  },
  data() {
    return {
      client_id: '',
       clients: [],
      orders: [],
      users: [],
      username: '',
      start_date: this.getStartDate(),
        end_date: new Date().toISOString().slice(0,10),
      currentSort: 'count',
      currentSortDir: 'desc',
      
     accessToken: '',
     clients_loading:true,
     orders_loading:true,
     VUE_APP_ASP_URL:process.env.VUE_APP_ASP_URL,

     range: '',
     
    }
  },
  created() {
      this.getAccessToken()
        .then(() => { 
            this.getOrders()
        });
      
    },
  methods: {
    async getAccessToken() {
        this.accessToken = await this.$auth.getTokenSilently()
    },
    exportXLS() {
		 //alert("hi")
		 var wb = XLSX.utils.table_to_book(document.getElementById('orderstable-excel'), {sheet:"Sheet 1"});
		 XLSX.writeFile(wb, 'Early Orders Report.xlsx')

	 },
   
    async getOrders() {
      this.orders_loading=true;
      OrderService.getOrders(this.accessToken, this.client_id, this.range, this.start_date, this.end_date, "", 1)
          .then(
            (orders => {
              
              
              // Work out the days early
              for(var i=0;i<orders.length;i++)
              {
                let deliverydate = new Date();
                deliverydate.setTime(Date.parse(orders[i].deliverydate_raw) + 7200000); // Adding the extra seconds to avoid it showing yesterday in BST
                
                let orderdate = new Date();
                orderdate.setTime(Date.parse(orders[i].orderdate_raw) );
                // Add on number of days
                let expecteddeliverydate = orderdate
                expecteddeliverydate.setDate(expecteddeliverydate.getDate() + orders[i].delivery_days);
                

                if(deliverydate.toISOString().slice(0,10) < expecteddeliverydate.toISOString().slice(0,10))
                {
                  let datedifference = expecteddeliverydate - deliverydate

                  orders[i].datedifference = Math.round( (datedifference / 1000 / 60 / 60 / 24), 0)
                  orders[i]["early"] = true;
                  orders[i].expecteddeliverydate = expecteddeliverydate.toLocaleString('en-GB').slice(0,10)
                  orders[i].expecteddeliverydate_iso = expecteddeliverydate.toISOString()
                  let thisUsername = orders[i].username
                  if(!this.users.some(data => data.username === thisUsername)){
                      this.users.push({'username': thisUsername, 'count' : 1});
                      
                    }else{
                      for(var j = 0; j< this.users.length; j++)
                      {
                        if(this.users[j].username === thisUsername)
                        {
                            this.users[j].count++
                            break;
                        }
                      }
                      
                    }
                }
                else{
                  orders[i]["early"] = false;
                }

                //alert(deliverydate.toISOString().slice(0,10) + ' ' + expecteddeliverydate.toISOString().slice(0,10))
                
                
                
              }


              this.$set(this, "orders", orders);
              this.orders_loading=false;
            }).bind(this)
          );
    },
    async getMyCustomers() {
      this.clients_loading=true;
        SalesService.getUserClients(this.accessToken)
        .then(
            (clients => {
            this.$set(this, "clients", clients);
            this.clients_loading=false;
            }).bind(this)
        );
    },
    getStartDate() {
            
            var d = new Date();
            
            d.setDate(d.getDate() - 7);
            return d.toISOString().slice(0,10);
             
        },
   
  },
  computed : {
     
     earlyOrders: function () {
        let earlyOrders = []
        earlyOrders = this.orders.filter(row => {
            if(this.username != '')
            {
              return row.early === true && row.username == this.username 

            }
            else{
              return row.early === true 
            }
            
            
          } )
       return earlyOrders
     } ,
     sortedUsers:function() {
            let newUsers = this.users
            
            return newUsers.sort((a,b) => {
                let modifier = 1;
                if(this.currentSortDir === 'desc') modifier = -1;
                if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
                if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
                return 0;
            });
        },

      report_total_qty: function() {
        return this.earlyOrders.reduce((total, item) => total + item.total_qty, 0);
      }

  },

 
  mounted() {
    
  },
  watch: {
    range: function () {
      this.users = []
      this.getOrders()
    },
    start_date: function () {
      this.users = []
      this.getOrders()
    },
    end_date: function () {
      this.users = []
      this.getOrders()
    },
  }
}



</script>


